import React from "react";

import CardComponent from "./Card"
import CardPaginator from "~/components/paginator"
import Announcements from '~/services/announcements';


const AnnouncementsPaginator = ({breakpoint})=> {

  return (
    <CardPaginator endpoint={Announcements.paginators.all} card={CardComponent} hideEmpty={true} options={{breakpoint}} />
  );
}

export default AnnouncementsPaginator;

